import '@backstage/cli/asset-types';
import React from 'react';
import Smartlook from 'smartlook-client';
import 'ag-grid-enterprise';
import { LicenseManager } from 'ag-grid-enterprise';
import App from './App';
import { createRoot } from 'react-dom/client';

LicenseManager.setLicenseKey(
  'Using_this_{AG_Charts_and_AG_Grid}_Enterprise_key_{AG-081710}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{deepc}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{deepcos}_only_for_{1}_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_working_on_{deepcos}_need_to_be_licensed___{deepcos}_has_been_granted_a_Deployment_License_Add-on_for_{1}_Production_Environment___This_key_works_with_{AG_Charts_and_AG_Grid}_Enterprise_versions_released_before_{14_October_2026}____[v3]_[0102]_MTc5MTkzMjQwMDAwMA==a5cf68214936ee37ec2b7d5b3fa59104',
);

let domain_arr = window.location.host.split('.');
let domain = domain_arr
  .slice(domain_arr.length - 2, domain_arr.length)
  .join('.');
let key;
switch (domain) {
  case 'deepc.pro':
    key = 'e24c14cbfc9547356b506a55600df215acf6caea';
    break;
  case 'deepc-engineering.de':
    key = '5306a35aaae7e24a76eef6979f0032b24e2ea871';
    break;
  default:
    key = '5306a35aaae7e24a76eef6979f0032b24e2ea871';
}

Smartlook.init(key);

const root = createRoot(document.getElementById('root')!);
root.render(<App />);
